import { render, staticRenderFns } from "./TimeZoneSwitcher.vue?vue&type=template&id=4894d217&scoped=true"
import script from "./TimeZoneSwitcher.vue?vue&type=script&lang=ts"
export * from "./TimeZoneSwitcher.vue?vue&type=script&lang=ts"
import style0 from "./TimeZoneSwitcher.vue?vue&type=style&index=0&id=4894d217&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4894d217",
  null
  
)

export default component.exports